import React from 'react'
import Logo from '../Logo'
import { useLocation } from 'react-router-dom'

const footerLinks = {
	'/': (
		<></>
	),
	'/produtos/prontuario': (
		<>
			<h3 className="font-semibold text-gray-900 mb-4 text-lg">Produto</h3>
			<ul className="space-y-2">
				<li><a href="#beneficios" className="text-gray-600 hover:text-primary transition-colors text-sm">Benefícios</a></li>
				<li><a href="#funcionamento" className="text-gray-600 hover:text-primary transition-colors text-sm">Como funciona?</a></li>
				<li><a href="#planos" className="text-gray-600 hover:text-primary transition-colors text-sm">Planos</a></li>
			</ul>
		</>
	)
}

export default function () {
	const { pathname: route } = useLocation()

	return (
		<footer className="bg-gray-50 py-12 px-16 border-t border-gray-100 print:hidden" style={{
			boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)'
		}}>
			<div className="container mx-auto">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					<div className="flex flex-col">
						<Logo />

						<p className="mt-4 text-gray-600 text-sm">
							Seus dados tratados com segurança e privacidade.
						</p>
					</div>

					<div>
						{footerLinks[route]}
					</div>

					<div>
						<h3 className="font-semibold text-gray-900 mb-4 text-lg">Institucional</h3>
						<ul className="space-y-2">
							<li><a href="/quem-somos" className="text-gray-600 hover:text-primary transition-colors text-sm">Quem somos</a></li>
							<li><a href="/termos-de-uso" className="text-gray-600 hover:text-primary transition-colors text-sm">Termos de Uso</a></li>
							<li><a href="/politica-privacidade" className="text-gray-600 hover:text-primary transition-colors text-sm">Política de Privacidade</a></li>
							<li><a href="/politica-reembolso" className="text-gray-600 hover:text-primary transition-colors text-sm">Política de Cancelamento</a></li>
							<li><a href="/contatos" className="text-gray-600 hover:text-primary transition-colors text-sm">Entre em contato</a></li>
						</ul>
					</div>
				</div>

				<div className="border-t border-gray-200 mt-12 pt-8 flex justify-center">
					<p className="text-gray-600 text-sm">
						&copy; {new Date().getFullYear()} Positronic Tech. Todos os direitos reservados.
					</p>
				</div>
			</div>
		</footer>
	)
}
